import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const AdminLoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { adminLogin } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await adminLogin(email, password);
            navigate('/admin');
        } catch (err) {
            setError(err.response?.data?.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-white flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <div className="bg-white border border-black p-12">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl font-light text-black mb-3 tracking-tight">
                            Admin
                        </h1>
                        <p className="text-gray-600 font-light">Sign in to manage Doctape</p>
                    </div>

                    {error && (
                        <div className="mb-6 p-4 bg-black text-white border border-black text-sm font-light">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm font-light text-black mb-3 tracking-wide">
                                Email Address
                            </label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="admin@doctape.com"
                                className="w-full px-6 py-3 border border-gray-300 text-black focus:outline-none focus:border-black font-light placeholder-gray-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-light text-black mb-3 tracking-wide">
                                Password
                            </label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Enter your password"
                                className="w-full px-6 py-3 border border-gray-300 text-black focus:outline-none focus:border-black font-light placeholder-gray-500"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-black text-white py-4 font-light tracking-wide hover:bg-gray-900 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed mt-8"
                        >
                            {loading ? 'Signing in...' : 'Sign In'}
                        </button>
                    </form>

                    {process.env.NODE_ENV !== 'production' && (
                        <div className="mt-12 pt-8 border-t border-gray-200">
                            <p className="text-sm text-gray-600 text-center mb-6 font-light">
                                Default Admin Credentials:
                            </p>
                            <div className="bg-white p-6 space-y-3 text-sm border border-gray-200">
                                <p className="text-gray-700 font-light">
                                    <span className="text-black font-light">Email:</span> superadmin@example.com
                                </p>
                                <p className="text-gray-700 font-light">
                                    <span className="text-black font-light">Password:</span> admin123
                                </p>
                                <p className="text-gray-600 text-xs mt-4 font-light">
                                    ⚠️ Change credentials in production environment
                                </p>
                            </div>
                        </div>
                    )}

                    <div className="mt-8 text-center">
                        <a href="/" className="text-black font-light hover:underline transition-colors border border-black px-6 py-3 inline-block hover:bg-black hover:text-white tracking-wide">
                            ← Back to Store
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLoginPage;
